import { forwardRef } from 'react';
import { Popover as BootstrapPopover } from 'react-bootstrap';
import type { PopoverProps as BootstrapPopoverProps } from 'react-bootstrap';
import classNames from 'classnames';

import { PopoverCheckbox, PopoverRadio } from './components/Input';
import PopoverItem from './components/Item';
import PopoverMenu from './components/Menu';

import styles from './_index.module.scss';

export interface PopoverProps extends BootstrapPopoverProps {
  header?: React.ReactNode;
  isScrollable?: boolean; // WIP in Figma
}

const Popover = (
  { children, className, header, isScrollable, ...props }: PopoverProps,
  ref?: React.ForwardedRef<HTMLDivElement>
) => {
  return (
    <BootstrapPopover
      className={classNames(styles['popover'], className, {
        [styles['is-scrollable']]: isScrollable,
      })}
      {...props}
      ref={ref}
    >
      {header && <BootstrapPopover.Header as="h4">{header}</BootstrapPopover.Header>}
      <div className={styles['popover-content']}>{children}</div>
    </BootstrapPopover>
  );
};

const PopoverWithRef = forwardRef(Popover);

export default Object.assign(PopoverWithRef, {
  Body: BootstrapPopover.Body,
  Checkbox: PopoverCheckbox,
  Header: BootstrapPopover.Header,
  Item: PopoverItem,
  Menu: PopoverMenu,
  Radio: PopoverRadio,
});
